import Header from "../components/Header";
import CreateForm from "./components/CreateForm";

function CreateOfferVouchers() {

    let pagesLinks = [
        {
            name: "أنشاء أكود",
            link: `/admin/vouchers`,
        },
        { name: "الصفحة الرئيسية", link: `/` },
        {
            name: "العروض",
            link: `/admin/offers`,
        },
    ];
    return (
        <div>
            <Header pageName="أنشاء أكود" pages={pagesLinks} className="text-2xl" />

            <CreateForm />
        </div>
    );
}

export default CreateOfferVouchers;
